import React from 'react';
import { Sector } from '../../types/sector';
import styles from './SectorFilter.module.css';

interface SectorFilterProps {
  sectors: Sector[];
  selectedSectorId: number | null;
  onSectorSelect: (sectorId: number | null) => void;
}

const SectorFilter: React.FC<SectorFilterProps> = ({ 
  sectors, 
  selectedSectorId, 
  onSectorSelect 
}) => {
  return (
    <div className={styles.sectorFilterContainer}>
      <div className={styles.sectorFilterScroll}>
        {/* "All Products" button */}
        <button
          className={`${styles.sectorButton} ${selectedSectorId === null ? styles.active : ''}`}
          onClick={() => onSectorSelect(null)}
        >
          All Products
        </button>
        
        {/* Sector buttons */}
        {sectors.map((sector) => (
          <button
            key={sector.id}
            className={`${styles.sectorButton} ${selectedSectorId === sector.id ? styles.active : ''}`}
            onClick={() => onSectorSelect(sector.id)}
          >
            {sector.sector_name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SectorFilter; 